import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const SORT_KEY = 'sort';

export const useSortFlyoutOpenedState = () => {
  return useOpenedStateManager(SORT_KEY);
};
